import React from "react";
const InfoCadete=(cadeteDni)=>
{
    window.open('/cadeteEdit?dni='+cadeteDni, '_blank');
}
export default InfoCadete